//src/utils/currency.js
const DEFAULT_LOCALE = "id-ID";

export const formatRupiah = (value, options = {}) => {
  const amount = Number(value || 0);

  return new Intl.NumberFormat(DEFAULT_LOCALE, {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
    ...options,
  }).format(amount);
};

export const formatNilaiListing = (value) => {
  const amount = Number(value || 0);

  if (!Number.isFinite(amount)) {
    return "0";
  }

  const formatter = new Intl.NumberFormat(DEFAULT_LOCALE, {
    maximumFractionDigits: 1,
  });

  if (amount >= 1_000_000_000_000) {
    return `${formatter.format(amount / 1_000_000_000_000)} Triliun`;
  }

  if (amount >= 1_000_000_000) {
    return `${formatter.format(amount / 1_000_000_000)} Miliar`;
  }

  if (amount >= 1_000_000) {
    return `${formatter.format(amount / 1_000_000)} Juta`;
  }

  if (amount >= 1_000) {
    return `${formatter.format(amount / 1_000)} Ribu`;
  }

  return formatter.format(amount);
};

export const formatNilaiListingLengkap = (value) => {
  return formatRupiah(value);
};
